import { CHARACTER_COUNT } from '../../../../../shared/constants/global';
import { type FieldSchema, type ValidatorContext } from '../types';

import createBaseStringValidator from './baseStringValidator';

const createTextareaValidator = (context: ValidatorContext): FieldSchema =>
  createBaseStringValidator(context, {
    defaultMaxLength: CHARACTER_COUNT.TEXTAREA_MAX,
    useMinValidationForRequired: true,
    includeMinMaxValueValidation: true,
    includeExpressionValidation: true,
  });

export default createTextareaValidator;
